import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { AuthService } from '../../auth/auth-service';
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private _injector: Injector) {

  }
  handleError(error: any) {
    console.log(error);
  }
}



// WEBPACK FOOTER //
// ./src/opc/shared/services/errorhandling.service.ts